<ng-template #itemTemplate #selectedItemTemplate let-item>
    {{ item.iban }}
    <span class="text-gray-500"> {{ item.bank?.identifier }} </span>
</ng-template>
